"use client";

import { createContext, useContext, type ReactNode } from "react";
import { Button, Skeleton } from "@heroui/react";
import { APP_URL } from "@/lib/constants";

// Most pages are client components, so they can't render the server-side
// <NavAuth /> themselves. The locale layout renders it once and hands the
// result down through this context for the navbar to place.
const NavAuthSlotContext = createContext<ReactNode>(null);

export function NavAuthSlotProvider({ slot, children }: { slot: ReactNode; children: ReactNode }) {
  return <NavAuthSlotContext.Provider value={slot}>{children}</NavAuthSlotContext.Provider>;
}

export function useNavAuthSlot() {
  return useContext(NavAuthSlotContext);
}

// Same footprint as the signed-out pair so the navbar doesn't shift on swap.
export function NavAuthSkeleton() {
  return (
    <>
      <Skeleton className="hidden sm:block h-8 w-19 rounded-xl" />
      <Skeleton className="hidden md:block h-8 w-36 rounded-xl" />
    </>
  );
}

export function NavAuthButtons({ loggedIn }: { loggedIn: boolean }) {
  if (loggedIn) {
    return (
      <Button
        variant="primary"
        className="hidden md:flex h-8 min-h-0 rounded-xl px-4"
        render={(props) => (
          <a {...(props as React.AnchorHTMLAttributes<HTMLAnchorElement>)} href={`${APP_URL}/dashboard`} />
        )}
      >
        Dashboard
      </Button>
    );
  }

  return (
    <>
      <Button
        variant="secondary"
        className="hidden sm:flex h-8 min-h-0 rounded-xl px-4"
        render={(props) => (
          <a {...(props as React.AnchorHTMLAttributes<HTMLAnchorElement>)} href={`${APP_URL}/login`} />
        )}
      >
        Log in
      </Button>
      <Button
        variant="primary"
        className="hidden md:flex h-8 min-h-0 rounded-xl px-4"
        render={(props) => (
          <a {...(props as React.AnchorHTMLAttributes<HTMLAnchorElement>)} href={`${APP_URL}/signup`} />
        )}
      >
        500 free credits
      </Button>
    </>
  );
}
